var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "app-header" }, [
      _c("div", { staticClass: "bread-crumb" }, [
        _c(
          "ul",
          { staticClass: "list-item-container" },
          _vm._l(_vm.arrayStep, function(item, index) {
            return _c("li", { key: item, staticClass: "list-item" }, [
              _c(
                "a",
                {
                  staticClass:
                    "step-name-breadcrumb body-text scheduler-text-custom-color",
                  attrs: { href: "javascript:void(0)" }
                },
                [_vm._v(_vm._s(item))]
              ),
              _vm._v(" "),
              index != _vm.arrayStep.length - 1
                ? _c("div", {
                    staticClass: "arrow-icon",
                    attrs: { role: "navigation" }
                  })
                : _vm._e()
            ])
          })
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "animated fadeIn my-appointment-page body-content" },
      [
        _c("div", [
          _c(
            "h1",
            {
              ref: "focusTab",
              staticClass: "step-name h1-text",
              attrs: { tabindex: "0" }
            },
            [_vm._v("My Appointments")]
          ),
          _vm._v(" "),
          _c("div", [
            _c("div", [
              _c(
                "div",
                {
                  staticClass:
                    "my-appointment-info common-card scheduler-card-responsive"
                },
                [
                  _c("div", { staticClass: "map-wrapper" }, [
                    _c("div", { staticClass: "map-auto-detection" }, [
                      _c("img", { attrs: { src: _vm.imgSrc } })
                    ])
                  ]),
                  _vm._v(" "),
                  _vm._m(0),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-xs-12" }, [
                      _c("div", { staticClass: "appointment-info" }, [
                        _c("div", { staticClass: "client-info" }, [
                          _c("div", { staticClass: "calender-wrapper" }, [
                            _c("div", {
                              staticClass: "calendar-icon",
                              attrs: { "aria-label": "Event icon" }
                            }),
                            _vm._v(" "),
                            _c("div", {}, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "title-text label-text scheduler-text-custom-color"
                                },
                                [_vm._v("Event")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "client-name field-value body-text"
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.event.companyName) +
                                      " Event " +
                                      _vm._s(_vm.event.prefDate)
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "body-text type-flushot"
                              })
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "event-info" }, [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-sm-6 col-xs-12" }, [
                              _c("div", { staticClass: "date-wrapper" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "title-text label-text scheduler-text-custom-color"
                                  },
                                  [_vm._v("Date")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "field-value body-text" },
                                  [_vm._v(_vm._s(_vm.event.prefDate))]
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-sm-6 col-xs-12" }, [
                              _c("div", { staticClass: "time-wrapper" }, [
                                _vm.event.hasSpouse
                                  ? _c("div", [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "title-text label-text scheduler-text-custom-color"
                                        },
                                        [_vm._v("Time")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "field-value body-text time-slots"
                                        },
                                        [
                                          _c("div", [
                                            _vm._v(
                                              _vm._s(
                                                "Myself - " + _vm.event.timeSlot
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "space" }, [
                                            _vm._v(", ")
                                          ]),
                                          _vm._v(" "),
                                          _c("div")
                                        ]
                                      )
                                    ])
                                  : _c("div", [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "title-text label-text scheduler-text-custom-color"
                                        },
                                        [_vm._v("Time")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "field-value body-text"
                                        },
                                        [
                                          _vm._v(
                                            "\n                              " +
                                              _vm._s(_vm.event.timeSlot) +
                                              "\n                            "
                                          )
                                        ]
                                      )
                                    ])
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "room-location-wrapper" }, [
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-sm-6 col-xs-12" }, [
                                _c("div", { staticClass: "location-wrapper" }, [
                                  _c("div", {
                                    staticClass: "location-icon",
                                    attrs: { "aria-label": "Location icon" }
                                  }),
                                  _vm._v(" "),
                                  _c("div", {}, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "title-text label-text scheduler-text-custom-color"
                                      },
                                      [_vm._v("Location")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "field-value body-text" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.event.building
                                              ? _vm.event.building + ", "
                                              : ""
                                          ) + _vm._s(_vm.event.fullAddress)
                                        )
                                      ]
                                    )
                                  ])
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-sm-6 col-xs-12" }, [
                                _c("div", { staticClass: "room-wrapper" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "title-text label-text scheduler-text-custom-color"
                                    },
                                    [_vm._v("Room")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "field-value body-text" },
                                    [
                                      _vm._v(
                                        "\n                              " +
                                          _vm._s(_vm.event.eventLocation) +
                                          "\n                            "
                                      )
                                    ]
                                  )
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _vm._m(1)
                ]
              )
            ])
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _vm.landingThankYouText !== ""
      ? _c(
          "div",
          {
            staticClass:
              "more-information common-card scheduler-card-responsive margin-top-24px"
          },
          [
            _c("div", {
              staticClass: "body-text",
              domProps: { innerHTML: _vm._s(_vm.landingThankYouText) }
            })
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "group-button" }, [
      _c(
        "button",
        {
          staticClass:
            "ap-btn scheduler-button-custom-color secondary-custom cancel-btn",
          attrs: { role: "button" }
        },
        [_c("div", { staticClass: "content" }, [_vm._v("Cancel")])]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "ap-btn scheduler-button-custom-color reschedule-btn",
          attrs: { role: "button" }
        },
        [_c("div", { staticClass: "content" }, [_vm._v("Reschedule")])]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "group-button-for-small" }, [
      _c(
        "button",
        {
          staticClass: "ap-btn scheduler-button-custom-color reschedule-btn",
          attrs: { id: "rescheduleApptBtn", role: "button" }
        },
        [_c("div", { staticClass: "content" }, [_vm._v("Reschedule")])]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass:
            "ap-btn scheduler-button-custom-color secondary-custom cancel-btn",
          attrs: { id: "cancelApptBtn", role: "button" }
        },
        [_c("div", { staticClass: "content" }, [_vm._v("Cancel")])]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7015e692", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7015e692","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/preview/SchedulerPreviewMyAppointmentPage.vue
// module id = 1645
// module chunks = 1